import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ClipboardList, Home, MessageSquare, Truck } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';

const TABS = [
  { to: '/driver', label: 'Home', icon: Home, id: 'home', driverOnly: true },
  { to: '/moving/closings/mobile', label: 'Closings', icon: ClipboardList, id: 'closings' },
  { to: '/moving/crew', label: 'My Moves', icon: Truck, id: 'moves' },
  { to: '/moving/crew/messages', label: 'Messages', icon: MessageSquare, id: 'messages' },
];

const useUnreadMessages = (api) => {
  const [count, setCount] = useState(0);
  const { pathname } = useLocation();
  useEffect(() => {
    let alive = true;
    const load = () => api.get('/messages/unread-count').then(({ data }) => alive && setCount(data?.unread_count || 0)).catch(() => {});
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 20000);
    return () => { alive = false; clearInterval(t); };
  }, [api, pathname]);
  return count;
};

// Shared top tabs for the crew (driver + foreman) mobile app.
export const CrewTabs = () => {
  const { user, api } = useAuth();
  const unread = useUnreadMessages(api);
  const tabs = TABS.filter((t) => !t.driverOnly || user?.role === 'driver');
  return (
    <nav className="flex bg-slate-950 border-b border-slate-800" data-testid="crew-tabs">
      {tabs.map(({ to, label, icon: Icon, id }) => (
        <NavLink key={id} to={to} end data-testid={`crew-tab-${id}`}
          className={({ isActive }) => `relative flex-1 flex items-center justify-center gap-1.5 py-2.5 text-xs sm:text-sm font-semibold border-b-2 transition-colors ${
            isActive ? 'border-blue-500 text-white' : 'border-transparent text-slate-400 hover:text-slate-200'}`}>
          <Icon className="w-4 h-4" />{label}
          {id === 'messages' && unread > 0 && (
            <span className="min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-[10px] font-bold leading-[18px] text-center" style={{ color: '#fff' }}
              data-testid="crew-messages-unread">{unread > 99 ? '99+' : unread}</span>
          )}
        </NavLink>
      ))}
    </nav>
  );
};

export const isCrewRole = (user) => ['driver', 'foreman'].includes(user?.role);
